import React from 'react';
import { Trans } from 'react-i18next';
import SophisticatedTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SophisticatedTooltip';
import ErrorIcon from '@wix/da-ds/pkg/Icons/24x24/Error';

import s from './FolderCoverInfo.scss';

export interface Props {}

const FolderCoverInfo: React.FC<Props> = props => {
  return (
    /* prettier-ignore */
    <SophisticatedTooltip
      size="medium"
      aria-label="premium-folder-warning-tooltip"
      usePortal
      description={
        <Trans
          i18nKey={
            'mediapopup.changegallectioncover.premiumFolder.warningTooltip'
          }
        >
          This cover image will look blurry to most deviants. To fix this,{' '}
          <span className={s['emphasis']}>select</span> or{' '}
          <span className={s['emphasis']}>upload</span> a new cover image.
        </Trans>
      }
    >
      <ErrorIcon className={s['info-icon']} />
    </SophisticatedTooltip>
  );
};
FolderCoverInfo.displayName = 'FolderCoverInfo';

export default FolderCoverInfo;
